module.exports = __webpack_public_path__ + "img/About_three.e03a35b8.png";